import React, {
  useReducer,
  useEffect,
  useState
} from 'react';

import {
  Button,
  makeStyles,
  Grid
} from '@material-ui/core';

import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';

import DeleteIcon from '@material-ui/icons/Delete';

// Dropzone
import { DropzoneAreaBase } from 'material-ui-dropzone';

import { validate } from '../../../utils/validators';

import './Input.css';

const inputReducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH':
      return {
        ...state,
        isTouched: true
      };
    default:
      return state;
  }
};

const useStyles = makeStyles((theme) => ({
  prod: {
    backgroundColor: theme.palette.background.dark,
  },
  large: {
    maxWidth: '100%',
    maxHeight: '300px',
    display: 'block',
    margin: '0 auto'
  },
  button: {
    margin: '15px auto'
  },
  remover: {
    marginLeft: '15px',
    marginTop: '15px',
  },
  grid: {
    textAlign: 'center',
    width: '100%',
    display: 'block'
  },
  dropzone: {
    margin: '0px 0px 10px 0px'
  },
}));

const Destaque = (props) => {
  const classes = useStyles();
  const {
    id,
    extraClass,
    errorText,
    onInput,
    validators,
    initialValue,
    initialValid,
  } = props;

  const [inputState, dispatch] = useReducer(inputReducer, {
    value: initialValue || '',
    isValid: initialValid || false,
    isTouched: initialValid || false
  });

  const {
    value,
    isValid
  } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const [previewUrl, setPreviewUrl] = useState();
  const [arquivos, setArquivos] = useState([]);

  useEffect(() => {
    console.log('Valor do input');
    console.log(value);
    if (!value) {
      setPreviewUrl(false);
      return;
    }
    if (typeof value === 'string') {
      if (value.includes(process.env.REACT_APP_BACKEND_IMG)) {
        setPreviewUrl(value);
      }
    } else {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setPreviewUrl(fileReader.result);
      };
      fileReader.readAsDataURL(value);
    }
  }, [value]);

  const removeImageHandler = () => {
    dispatch({ type: 'CHANGE', val: '', validators });
  };

  const handleUpload = (files) => {
    setArquivos(files);
    if (files && files.length === 1) {
      const pickedFile = files[0];
      dispatch({ type: 'CHANGE', val: pickedFile.file, validators });
    }
  };

  console.log(arquivos);

  return (
    <div>
      {previewUrl === false && (
        <DropzoneAreaBase
          acceptedFiles={['image/jpeg', 'image/png', 'image/bmp']}
          dropzoneText="Arraste uma imagem para cá ou clique para selecionar o arquivo."
          filesLimit={1}
          Icon={PhotoCameraIcon}
          dropzoneClass={classes.dropzone}
          showPreviews
          showPreviewsInDropzone
          useChipsForPreview
          showAlerts
          maxFileSize={3000000}
          onAdd={handleUpload}
          getFileLimitExceedMessage={(filesLimit) => (`Limite máximo de ${filesLimit} arquivos atingido.`)}
          getFileAddedMessage={(fileName) => (`O arquivo ${fileName} foi adicionado para upload com sucesso.`)}
          getFileRemovedMessage={(fileName) => (`O arquivo ${fileName} foi rejeitado.`)}
          getDropRejectMessage={(rejectedFile) => (`O arquivo ${rejectedFile.name} foi rejeitado.`)}
        />
      )}
      <div className={`image-upload ${extraClass && 'center'}`}>
        <div className="image-upload__preview">
          {previewUrl && <img alt="Remy Sharp" src={previewUrl} className={`${classes.large} ${extraClass}`} />}
        </div>
        <Grid container alignContent="center" alignItems="center" justify="center" spacing={3}>
          <Grid item xs={12} className={classes.grid}>
            {previewUrl && (
              <Button
                aria-label="delete"
                className={classes.remover}
                type="button"
                variant="contained"
                color="default"
                size="small"
                onClick={removeImageHandler}
                endIcon={<DeleteIcon />}
              >
                REMOVER FOTO
              </Button>
            )}
          </Grid>
        </Grid>
      </div>
      {!isValid && <p>{errorText}</p>}
    </div>
  );
};
export default Destaque;
